/* eslint-disable @typescript-eslint/no-floating-promises */
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useEffect } from 'react';
import { Typography } from '@mui/material';
import qs from 'qs';
import { useOidc } from '@axa-fr/react-oidc';
import LandingLayout from './LandingLayout';
import { useLocation } from 'react-router-dom';
import { LOGGINGOUT } from './MikeLogin';
import MikeButton from '../mike-button';
import { t } from '../../translations/i18n';

const notesStyle = 
  css`
    margin-top: 20px;
    display: inline-block;
  `;

const containerStyle = 
  css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `;

const LandingPage = () => {
  const { login } = useOidc();

  const { search, pathname } = useLocation();

  const pathAndSearch = search.length > 1 ? pathname + search : pathname;

  useEffect(() => {
    const loggingOut = sessionStorage.getItem(LOGGINGOUT);
    sessionStorage.removeItem(LOGGINGOUT);
    if (loggingOut !== 'true') {
      let extras: { prompt: string; tenantId?: string } = { prompt: 'none' };
      if (search) {
        const parameters = qs.parse(search.replace('?', '')) || {};
        if (parameters.tenantId) {        
          extras = { ...extras, tenantId: parameters.tenantId.toString() };
        }
      }
      login(pathAndSearch, extras);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LandingLayout>
      <div css={containerStyle}>    
        <MikeButton color="secondary" variant="contained" onClick={() => login(pathAndSearch)}>
          {t('PLEASE_LOG_IN')}
        </MikeButton>
      
        <Typography variant="caption" css={notesStyle}>
          <label>{t('UNSURE_ABOUT_YOUR_SUBSCRIPTION') + ' '}</label>
          &nbsp;
          <a href="mailto:mike@dhigroup.com">{t('CONTACT_US')}</a>.
        </Typography>
     
      </div>
    </LandingLayout>
  );
};

export default LandingPage;
